module.exports = __webpack_public_path__ + "static/media/img27.e3352539.JPG";